import Button from 'assets/components/button/Button';
import LinkButton from 'assets/components/button/LinkButton';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Card from 'assets/components/card/Card';
import ThemeCardRow from 'assets/components/card/themes/Theme.Card.Row';
import Collection from 'assets/components/data/Collection';
import ThemeCollectionTable from 'assets/components/data/themes/Theme.Collection.Table';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperPaper from 'assets/themes/wrappers/Theme.Wrapper.Paper';
import { combineStrings } from 'assets/utils/data/String';

type PreviewDocument = {
  id: number;
  url: string;
  infoUrl?: string;
  name: string;
  orderNumber?: number;
  description?: string;
  info?: string;
  isEditing?: boolean;
  isDeletable?: boolean;
  onDelete?(): void;
  onClick?(): void;
  onReorder?(delta: -1 | 1): void;
};
type Props = {
  documents: PreviewDocument[];
  documentPageName?: string;
  children?: any;
};
export default function ProductDocumentPreview(props: Props) {
  const { lang } = getLocales();

  return (
    <Collection class={combineStrings(' ', ThemeCollectionTable, ThemeWrapperPaper)} style={{ padding: 0 }}>
      {props.children}
      {!props.documents?.length ? (
        <ErrorWrapper children={lang.noFiles} />
      ) : (
        <DataMap
          data={props.documents}
          render={({ data: doc, index, isFirst, isLast }) => (
            <Card
              key={index}
              class={ThemeCardRow}
              title={doc.orderNumber ? `#${doc.orderNumber} ${doc.name}` : doc.name}
              subtitle={doc.description}
              info={doc.info}
              media={<Icon class="fas-file" />}
              actions={
                <>
                  {doc.onReorder && (
                    <>
                      <Button
                        class={ThemeButtonCircle}
                        media={<Icon class="fas-chevron-up" />}
                        onClick={doc.onReorder}
                        data={-1}
                        disabled={isFirst}
                        htmlElementProps={{ title: lang.moveUp }}
                      />
                      <Button
                        class={ThemeButtonCircle}
                        media={<Icon class="fas-chevron-down" />}
                        onClick={doc.onReorder}
                        data={1}
                        disabled={isLast}
                        htmlElementProps={{ title: lang.moveDown }}
                      />
                    </>
                  )}
                  <Button
                    class={ThemeButtonCircle}
                    media={<Icon class={doc.isEditing ? 'fas-ban' : 'fas-edit'} />}
                    onClick={doc.onClick}
                    disabled={!doc.onClick}
                    htmlElementProps={{ title: doc.isEditing ? lang.cancel : lang.edit }}
                  />
                  <LinkButton
                    class={ThemeButtonCircle}
                    url={doc.url}
                    media={<Icon class="fas-download" />}
                    target="_blank"
                    disabled={!doc.id || doc.isEditing}
                    htmlElementProps={{ title: lang.download }}
                  />
                  <LinkButton
                    class={ThemeButtonCircle}
                    url={doc.infoUrl}
                    media={<Icon class="fas-file-contract" />}
                    disabled={!doc.id || doc.isEditing}
                    htmlElementProps={{ title: props.documentPageName ?? lang.productDocuments }}
                  />
                  <Button
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    disabled={!doc.onDelete || doc.isEditing || !doc.isDeletable}
                    onClick={doc.onDelete}
                    htmlElementProps={{ title: lang.delete }}
                  />
                </>
              }
            />
          )}
        />
      )}
    </Collection>
  );
}
